<template>
  <div>
    <swiper
      :options="swiperOption"
      ref="slider"
      :class="reachEndless ? 'shadow-left' : 'shadow-right'"
    >
      <swiper-slide
        class="slide-width"
        v-for="(model, index) in models"
        :key="index"
      >
        <a
          :href="`/model/${model.name_alias}/${model.id}/`"
          class="model-card d-block"
          target="_blank"
          v-metric="'LENDING-BIM_CLICK-ON-MODEL'"
        >
          <a
            :href="
              `/manufacturer/${model.alias_organization}/${model.id_organization}/`
            "
            class="d-flex flex-column align-end model_manufacturer-logo"
            :title="`Перейти на страницу ${model.name_organization}`"
            target="_blank"
            v-metric="'LENDING-BIM_CLICK-ON-MODEL-MANUFACTURER'"
          >
            <img
              class="mw-100"
              :src="model.logo.link"
              v-if="
                model.logo.link !== '' &&
                  model.logo.link !== null &&
                  model.logo.link !== undefined
              "
              :alt="model.name_organization"
            />
            <img
              class="mw-100"
              src="/dist/assets/front_white/img/svg/no-logo.svg"
              v-else
              alt="no logo"
            />
          </a>
          <div class="model-image_block">
            <img
              class="model-image"
              v-if="
                model.link_picture !== '' &&
                  model.link_picture !== null &&
                  model.link_picture !== undefined
              "
              :src="model.link_picture"
              :alt="model.name"
            />
            <img
              class="model-image"
              v-else
              src="/dist/assets/front_white/img/svg/no-pic.svg"
              alt="no picture"
            />
          </div>
          <p class="model-descr mx-6 fz14">{{ model.name_short }}</p>
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
// import 'swiper/dist/css/swiper.css'
import 'swiper/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default {
  components: {
    Swiper, SwiperSlide
  },
  data() {
    return {
      models: [],
      reachEndless: null,
      swiperOption: {
        breakpoints: {
          // when window width is <= 640px
          0: {
            onlyExternal: false,
            slidesPerView: 2,
            spaceBetween: 10,
            slidesPerGroup: 1,
          },
          767.9: {
            onlyExternal: false,
            slidesPerView: 3,
            spaceBetween: 10,
            slidesPerGroup: 1,
          },
          1199.9: {
            // onlyExternal: false,
            slidesPerView: 6,
            spaceBetween: 20,
            slidesPerGroup: 1,
          },
        },
        grabCursor: true,
        loop: false,
        on: {
          reachBeginning: () => {
            this.reachEndless = false
          },
          reachEnd: () => {
            this.reachEndless = true
          },
          init: () => {
            this.reachEndless = false
          },
        },
      },
    }
  },
  created() {
    this.getModels()
  },
  methods: {
    getModels(val) {
      const data = new URLSearchParams()
      data.append(
        'modelsid',
        '20278, 7087, 4553, 8307, 15202, 9635, 19353, 18740, 15195, 18909, 15629, 4429'
      )
      axios
        .post('/?m=BimModelsList&a=GetModelsArrayID', data)
        .then(response => {
          this.models = response.data
        })
        .catch(function(error) {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import './src/front_white/sass/components/settings';

.model-card,
.slide-width {
  width: 12.1333rem;
  min-width: 12.1333rem;
  height: 18.7333rem;
  min-height: 18.7333rem;
  padding-bottom: 0;
  @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
    width: unset;
    min-width: unset;
  }
}
.shadow-right {
  position: relative;
  z-index: 1;
  padding-bottom: 4px;
  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    pointer-events: none;

    width: 13.7333rem;
    height: 100%;
    z-index: 2;

    background-image: linear-gradient(to left, #ffffff, rgba(255, 255, 255, 0));
  }
}

.shadow-left {
  @extend .shadow-right;
  &:after {
    right: unset;
    left: 0;
    background-image: linear-gradient(
      to right,
      #ffffff,
      rgba(255, 255, 255, 0)
    );
  }
}
</style>
